import { Component, OnInit } from '@angular/core';
import { CommonServices } from 'src/app/Common/CommonServices';
import { PlatformChargesClient, RoomOwnerAccountDetail, User } from 'src/app/Services/WOWApi.Service';
import { EditHostAccountDetailComponent } from '../edit-host-account-detail/edit-host-account-detail.component';
import { openConfirmDialog } from 'src/app/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'app-host-account-detail',
    templateUrl: './host-account-detail.component.html',
    styleUrls: ['./host-account-detail.component.css'],
    standalone: false
})
export class HostAccountDetailComponent implements OnInit {
  userDetails: User;
  accountDetaiils: RoomOwnerAccountDetail[] = [];
  constructor(
    private platformChargesClient: PlatformChargesClient,
    private commonServicers: CommonServices,
    private dialog: MatDialog
  ) {
    this.userDetails = JSON.parse(localStorage.getItem("UserInfo"));
  }

  ngOnInit(): void {
    this.getAllAccountDetails();
  }

  getAllAccountDetails() {
    this.platformChargesClient.getAllAccountDetails(this.userDetails.id).subscribe(res => {
      this.accountDetaiils = res;
    }, error => {
      this.commonServicers.showMessage('error', error, 3);
    });
  }

  onUpdateAccountDetails(account: RoomOwnerAccountDetail) {
    console.log(account);
    if (account.isUpdateAllowed === false) {
      this.commonServicers.showMessage('error', 'Update not allowed.', 5);
      return;
    }
    this.dialog.open(EditHostAccountDetailComponent, {
      width: 'calc(auto - 90px)',
      height: "calc(auto - 150px)",
      maxHeight: '70vh',
      data: {
        account: account,
        isNewAccount: false
      }
    }).afterClosed().subscribe(res => {
      console.log(res);
      if (res !== undefined && res !== null && res.action === 'update') {
        const idx = this.accountDetaiils.findIndex(x => x.accountId === account.accountId);
        const details = JSON.parse(JSON.stringify(this.accountDetaiils));
        details[idx] = res.obj;
        this.accountDetaiils = details;
      }
    });
  }

  onAddPaymentAction() {
    this.dialog.open(EditHostAccountDetailComponent, {
      width: 'calc(auto - 90px)',
      height: "calc(auto - 150px)",
      maxHeight: '70vh',
      data: {
        isNewAccount: true
      }
    }).afterClosed().subscribe(res => {
      if (res !== undefined && res !== null && res.action === 'refresh') {
        this.getAllAccountDetails();
      }
    });
  }

  onDeleteAccount(account: RoomOwnerAccountDetail) {
    openConfirmDialog(this.dialog, {
        message: 'Are you sure, you want to delete the account ?',
        buttonText: {
          ok: 'Yes, Delete',
          cancel: 'No, Cancel'
        }
    }).afterClosed().subscribe(res => {
      if (res === true) {
        this.platformChargesClient.deleteAccountDetail(account.accountId).subscribe(res => {
          if (res === true) {
            const idx = this.accountDetaiils.findIndex(x => x.accountId === account.accountId);
            const details = JSON.parse(JSON.stringify(this.accountDetaiils));
            details.splice(idx, 1);
            this.accountDetaiils = details;
            this.commonServicers.showMessage('success', 'Account deleted successfully');
          }
        })
      }
    })
  }

  onChangeActiveStatus(account: RoomOwnerAccountDetail) {
    const status = account.isActive ? 'Active' : 'In-Active';
    openConfirmDialog(this.dialog, {
        message: `Are you sure, you want to mark this account ${status} ?`,
        buttonText: {
          ok: 'Yes, Do It',
          cancel: 'No, Cancel'
        }
    }).afterClosed().subscribe(res => {
      if (res === true) {
        this.platformChargesClient.markRoomOwnerAccountDetailActive(account.accountId, this.userDetails.id).subscribe(res => {
          if (res === true) {
            const list = JSON.parse(JSON.stringify(this.accountDetaiils));
            this.accountDetaiils = [];
            list.map(x => {
              if (x.accountId !== account.accountId) {
                x.isActive = false;
              }
            });
            this.accountDetaiils = list;
          } else {
            this.revertActiveToLastState(account);
          }
        }, error=> {
          this.commonServicers.showMessage('error', error, 4);
          this.revertActiveToLastState(account);
        })
      } 
      if (res === false) {
        this.revertActiveToLastState(account);
      }
    })
  }

  revertActiveToLastState(account: RoomOwnerAccountDetail) {
    const idx = this.accountDetaiils.findIndex(x => x.accountId === account.accountId);
    if (idx > -1) {
      account.isActive = !account.isActive;
      const list = JSON.parse(JSON.stringify(this.accountDetaiils));
      this.accountDetaiils = [];
      list[idx] = account;
      this.accountDetaiils = list;
    }
  }

  convertAccountNumber(accountNumber: number): string {
    if (accountNumber === null || accountNumber === undefined) {
      return '';
    }
    return '********' + accountNumber.toString().slice(-4);
  }

}
